import { configureStore } from '@reduxjs/toolkit';

// Create a dummy reducer to prevent the error
const dummyReducer = (state = {}, action) => {
  return state;
};

const store = configureStore({
  reducer: {
    dummy: dummyReducer
  },
});

export { store };


